export const imagenes = require.context("../assets/imagenes/", true);
